import i18n from '@/plugins/i18n'

type UseTranslationParams = {
  keyPrefix: string,
}
type UseTranslationReturn = {
  t: (key: string, params?: Record<string, unknown>) => string
}

export function useTranslation ({ keyPrefix }: UseTranslationParams): UseTranslationReturn {
  const t = (key: string, params: Record<string, unknown> = {}) => {
    return i18n.global.t(`${keyPrefix}.${key}`, params).toString()
  }

  return { t }
}
